
import { formatSideLabel, isYesNoSide } from "@/lib/selection-side";

export { formatSideLabel, isYesNoSide };

const OPPOSITE_SIDE: Record<string, string> = {
  OVER: "UNDER",
  UNDER: "OVER",
  HOME: "AWAY",
  AWAY: "HOME",
  YES: "NO",
  NO: "YES",
};

type OppositeLabelInput = {
  opponent?: string | null;
  line?: number | null;
  market_display?: string | null;
  stat_type?: string | null;
};

function toTitleCase(str: string): string {
  if (!str) return str;
  return str
    .split(" ")
    .map((word) => {
      if (word === word.toUpperCase() && word.length <= 4) {
        return word;
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
}

export function getSideLabels(betType: string): {
  selectionLabel: string;
  oppositeLabel: string;
} {
  const opposite = OPPOSITE_SIDE[(betType || "").toUpperCase()];
  if (!opposite) {
    return { selectionLabel: betType || "Selection", oppositeLabel: "Opposite" };
  }
  return { selectionLabel: formatSideLabel(betType), oppositeLabel: formatSideLabel(opposite) };
}

export function buildOppositeLabel(
  row: OppositeLabelInput,
  fallbackLabel: string
): string {
  const opponent = toTitleCase(row.opponent || "");
  const line = row.line;
  const marketDisplay = row.market_display || row.stat_type || "";

  if (marketDisplay.toLowerCase().includes("spread") && typeof line === "number") {
    const oppLine = -line;
    const sign = oppLine >= 0 ? "+" : "";
    return `${sign}${oppLine}`;
  }

  if (marketDisplay.toLowerCase().includes("moneyline") || marketDisplay.toLowerCase().includes("ml")) {
    return opponent || fallbackLabel;
  }

  return opponent || fallbackLabel;
}
